import { type ReactElement } from 'react';

import type { TimelineEvent } from '../lib/parent-portal-api';

function formatWhen(iso: string): string {
  return new Date(iso).toLocaleString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function TimelineList({
  events,
  limit,
}: {
  events: TimelineEvent[];
  limit?: number;
}): ReactElement {
  const visible = limit ? events.slice(-limit) : events;

  if (visible.length === 0) {
    return <p className="text-muted">No activity recorded yet.</p>;
  }

  return (
    <ol className="timeline">
      {visible.map((event, index) => (
        <li
          key={`${event.type}-${event.timestamp}-${index}`}
          className="timeline-item is-done"
        >
          <span className="timeline-dot" />
          <p className="timeline-title">{event.title}</p>
          <p className="timeline-meta">
            {formatWhen(event.timestamp)}
            {event.actorDisplayName ? ` · ${event.actorDisplayName}` : ''}
          </p>
          {event.note ? <p className="timeline-note">{event.note}</p> : null}
        </li>
      ))}
    </ol>
  );
}
